import { DesignTokenColor } from '@src/theme';
import { IconColor, IconVariant } from './interface';

type ColorMap = [DesignTokenColor, DesignTokenColor?];

const DEFAULT_COLOR: ColorMap = ['controls.primary', 'surface.paper'];
const COLOR_MAP: Record<IconColor, ColorMap> = {
  info: ['state.info.secondary', 'state.info.backing-1'],
  success: ['state.success.secondary', 'state.success.backing-1'],
  warning: ['state.warning.secondary', 'state.warning.backing-1'],
  error: ['state.error.secondary', 'state.error.backing-1'],
  primary: ['state.teal.secondary', 'state.teal.backing-1'],
  secondary: ['controls.primary', undefined],
  tertiary: ['accent.secondary', 'accent.backing-1'],
};

type ColorCombo = { bgColor?: DesignTokenColor; color?: DesignTokenColor };
export function getIconVariantColors(color?: IconColor, variant?: IconVariant): ColorCombo {
  const [mainColor, backingColor] = (color && COLOR_MAP[color]) || DEFAULT_COLOR;

  return variant === 'dark'
    ? { bgColor: mainColor, color: 'surface.paper' }
    : { bgColor: backingColor, color: mainColor };
}
